import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
// import echarts from "@/utils/echarts"
import Moment from 'moment'
import api from './api'
import preventClick  from './utils/clickOnceAtime'
import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css'
import "./common/common.css"

// Vue.use(VueRouter)
// import 'vue.config.js'
// require("./mock/mock.js")
Vue.use(preventClick)
Vue.use(ElementUI)
// 将api挂载到vue的原型上
Vue.prototype.$api = api;
Vue.prototype.$echarts = echarts
Vue.prototype.moment = Moment
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js